import Raven from 'raven-js';
import LoginAPI from '../api/LoginAPI';
export const redirect = redirectUrl => {
  LoginAPI.validateRedirectUrl(redirectUrl).then(loginValidateRedirectResponse => window.location = loginValidateRedirectResponse.loginRedirectUrl).catch(error => Raven.captureMessage('Failed to validate redirect url', {
    extra: error
  }));
};